import { FC } from "react";
import { SearchFormInputs } from "src/Modules/Flights/constants";
import { SelectChips } from "src/components";
import {
  OriginComponent,
  DestinationComponent,
  ClassSelect,
  PassengerSelect,
  DepartureComponent,
  ArrivalComponent,
  DirectFlightComponent,
  SubmitComponent,
  TripSelectionComponent,
} from "../../FlightSearchForm";

const SearchWebLayout: FC<{ values: Partial<SearchFormInputs>; errorFields: string[] }> = ({ values, errorFields }) => {
  return (
    <div className="flex w-full flex-wrap items-center gap-4">
      <div className="flex w-full xl:items-center justify-between gap-1 lg:gap-4 xl:flex-row flex-col">
        <TripSelectionComponent />
        <div className="flex items-center gap-2 xl:gap-5 justify-end">
          <DirectFlightComponent />
          <SelectChips rounded="md" classNames={{
            item:"hover:border-background-primary! border-border-default",

          }}>
            <div className="m-0! h-8! md:h-full! w-full cursor-pointer select-none whitespace-nowrap rounded-none transition-all duration-200 md:w-full">
              <ClassSelect wrapperProps={{ className: "p-3! hover:text-background-primary" }} />
            </div>
            <div className="m-0! h-8! md:h-full! w-full cursor-pointer select-none whitespace-nowrap rounded-none transition-all duration-200 md:w-full">
              <PassengerSelect wrapperProps={{ className: "p-3! hover:text-background-primary" }} />
            </div>
          </SelectChips>
        </div>
      </div>
      <div className="flex min-w-full grow flex-wrap gap-2 rounded-md border bg-background-default border-border-default p-3">
        <OriginComponent errorFields={errorFields} />
        <DestinationComponent errorFields={errorFields} />
        <div className="w-px self-stretch bg-border-default" />
        <DepartureComponent errorFields={errorFields} />
        <ArrivalComponent values={values} errorFields={errorFields} />
        <SubmitComponent />
      </div>
    </div>
  );
};

export default SearchWebLayout;
